import api from '../api'

// initial state
const state = {
  courses: {
    list: [],
    pageCount: 0,
    totalCount: 0,
    pageIndex: 1,
    pageSize: 10
  },

  lessons: {
    list: [],
    pageCount: 0,
    totalCount: 0,
    pageIndex: 1,
    pageSize: 10,
    attachment: {
      list: [],
      pageCount: 0,
      totalCount: 0,
      pageIndex: 1,
      pageSize: 10
    }
  }
}

// getters
const getters = {
  courses: state => state.courses,
  courseLessons: state => state.lessons
}

// actions
const actions = {
  getCourses: ({ commit, state }, pageIndex, pageSize, orderby) => {
    let params = {
      pageIndex: pageIndex || state.courses.pageIndex,
      pageSize: pageSize || state.courses.pageSize,
      orderby: orderby || state.courses.orderby
    }

    api.get('/Course', { params: params })
      .then((response) => {
        console.log(response.data)
        commit('updateCourses', response.data)
      })
  },

  getCourseLessons: ({dispatch, commit, state}, courseId) => {
    api.get('/Course/' + courseId + '/Lessons')
      .then((response) => {
        commit('updateLessons', response.data)
        dispatch('getCourseLessonAttachment', courseId)
      })
  },

  getCourseLessonAttachment: ({commit, state}, courseId) => {
    api.get('/Course/' + courseId + '/Attacheds')
      .then((response) => {
        commit('updateAttachment', response.data)
      })
  },

  getAttachment ({state}, id) {
    api.get('/Course/Attacheds/' + id + '/DownloadUrl')
      .then((res) => {
        let link = document.createElement('a')
        link.href = res.data.data
        link.click()
      })
  }
}

// mutations
const mutations = {
  updateCourses (state, payload) {
    state.courses.list = payload.data || []
    state.courses.pageCount = payload.pageCount
    state.courses.totalCount = payload.totalCount
    state.courses.pageIndex = payload.pageIndex
    state.courses.pageSize = payload.pageSize
  },

  updateLessons (state, payload) {
    state.lessons.list = payload.data || []
    state.lessons.pageCount = payload.pageCount
    state.lessons.totalCount = payload.totalCount
    state.lessons.pageIndex = payload.pageIndex
    state.lessons.pageSize = payload.pageSize
  },

  updateAttachment (state, payload) {
    state.lessons.attachment.list = payload.data || []
    state.lessons.attachment.pageCount = payload.pageCount
    state.lessons.attachment.totalCount = payload.totalCount
    state.lessons.attachment.pageIndex = payload.pageIndex
    state.lessons.attachment.pageSize = payload.pageSize
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/course.js